import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { LiabilityReviewSnapshot } from "@recobra/schemas/task";
import type { TaskType } from "@recobra/schemas/task-catalog";

import { TaskModalSection, TaskSummaryList, TaskSummaryRow } from "../task-display";

export const LiabilityReviewedValues: FC<{
  taskType: Pick<TaskType, "system" | "scope"> | undefined;
  values?: LiabilityReviewSnapshot;
}> = ({ taskType, values }) =>
  taskType?.system === "analyze_case_liability" && taskType.scope === "third_party_claim" ? (
    <TaskModalSection>
      <TaskSummaryList>
        <TaskSummaryRow label={m.liability_analysis_field_accident_dynamics()}>
          {values?.accidentDynamics
            ? m.accident_dynamics_label({ dynamics: values.accidentDynamics })
            : m.common_em_dash()}
        </TaskSummaryRow>
        <TaskSummaryRow label={m.liability_analysis_field_guilt_degree()}>
          {values?.guiltDegree
            ? m.guilt_degree_label({ degree: values.guiltDegree })
            : m.common_em_dash()}
        </TaskSummaryRow>
      </TaskSummaryList>
    </TaskModalSection>
  ) : null;
